import { Component, inject, OnInit } from '@angular/core';
import { DynamicFormArray, FieldSelectedValue, Props } from '../../model/form.model';
import { ButtonNames, BUTTON_NAMES } from '../../model/common.model';
import { FieldTypesForOptions } from '../../model/form-fields.model';
import { DataTableSchema } from '../../model/dynamic-data-table.model';
import { GlobalApiService } from '../../services/global-api.service';
import { SearchConfig } from '../../model/api.model';
import { ManageExceptionFilterTitle } from '../../model/dealer-training-billing-manage-exception-report.model';

@Component({
  selector: 'app-base',
  standalone: true,
  imports: [],
  templateUrl: './base.component.html'
})
export abstract class BaseComponent implements OnInit {
  protected abstract data: string;
  protected abstract filterSchema: DynamicFormArray;
  protected abstract dataTableSchema: DataTableSchema;
  protected abstract props: Props;
  protected sortBy:any = null;
  globalService = inject(GlobalApiService);
  ngOnInit(): void {
    this.onResetClicked();
    this.runCommonLogic();
  }

  protected runCommonLogic(): void {
    this.updateLayoutButtonCallbacks();
    this.updateOptions();
  }

  public commonFunction(): void {
    // console.log('This is the interface for the common Function') 
  }
  updateLayoutButtonCallbacks() {
    this.filterSchema['onButtonClicked'] = this.onButtonClicked;
    this.filterSchema['onControlValueChanged'] = this.onControlValueChanged;
  }
  onControlValueChanged = (event: FieldSelectedValue) => {
    const field = this.filterSchema.FieldsArray.find((p) => p.fieldName === event.FieldName);
    if (field) {
      field.selectedValue = event.Value;
    }
    this.checkForAnyEmptyFields();
  }
  onButtonClicked = (event: { name: ButtonNames, postParams: { searchConfig: SearchConfig }, source?: 'user' | 'navigation' }) => {
    if (event.name === BUTTON_NAMES.Reset || event.name === BUTTON_NAMES.Cancel) {
      this.onResetClicked(event.source);
    }
    else if (event.name === BUTTON_NAMES.Search || event.name === BUTTON_NAMES.Create) {
      this.onSearchClicked(event?.postParams?.searchConfig);
    }
    else {
      throw new Error('Method not implemented.');
    }
  }
  onResetClicked = (_source?: 'user' | 'navigation') => {
    this.filterSchema.FieldsArray = this.filterSchema.FieldsArray.map((field) => ({ ...field, selectedValue: field['defaultValue'] ? field['defaultValue'] : '' }));
    this.dataTableSchema = {
      ...this.dataTableSchema,
      inputFilter: '',
      dataSource: []
    };
    this.resetSorting()
    this.checkForAnyEmptyFields();
  };
  checkForAnyEmptyFields = () => {
    let enableButtons = true;
    const emptyFieldsLength = this.filterSchema.FieldsArray.some((p) => {
    const val = p.selectedValue;  
      return !!val && ((typeof val === 'string' && val.trim() !== '') || 
        (typeof val === 'number' && val !== 0) || (Array.isArray(val) && val.length > 0) ||
        (typeof val === 'object' && !Array.isArray(val) && Object.keys(val).length > 0))
    });
    enableButtons = !emptyFieldsLength;
    if(!emptyFieldsLength && (this.filterSchema.title !== ManageExceptionFilterTitle)){
        if(this.dataTableSchema.serverSidePaginatation){
        this.dataTableSchema['pageSizeOptions']['pageLength']=0;
        }
    }
    this.disableEnableButtons(enableButtons);
  };
  disableEnableButtons = (input: boolean) => {
    if (this.filterSchema.ButtonsArray) {
      if (this.filterSchema.alwaysEnableButtons) {
        this.filterSchema.ButtonsArray = this.filterSchema.ButtonsArray.map((field) => ({ ...field, isDisabled: false }));
      } else {
        this.filterSchema.ButtonsArray = this.filterSchema.ButtonsArray.map((field) => ({ ...field, isDisabled: input }));
      }
    }
  };
  updateOptions = ():any => {
    this.filterSchema.FieldsArray.forEach(filterField => {
      if (FieldTypesForOptions.includes(filterField['fieldType']) && (filterField['options'] && filterField['options'].length <= 0)) {
        return this.globalService.getOptionsForField(filterField['fieldName']).then(options => {
          filterField['options'] = options;
          filterField['isLoading'] = false;
        }).catch(err => {
          console.info('Error Fetching options',err);
          filterField['options'] = [];
          filterField['isLoading'] = false;
        })
      }else{
        return Promise.resolve()
      }
    })
  }
  resetSorting = ():any =>{
    this.dataTableSchema.activeSorts = [];
    this.sortBy = {};
  }

  protected setTableLoadingState(isLoading: boolean): void {
    this.dataTableSchema.isLoading = isLoading;
  }

  onSearchClicked = (_searchParam: SearchConfig):any => {

  };
}
